import images from '../../../api/images/hooks'
import Loader from '../../Common/Loader'
import { useBlobUrls } from '../../Hooks/useBlobUrl'
import styles from './TableImage.module.css'

interface TableImageProps {
    photoId: number
    alt?: string
    updated?: string
}

const TableImage = ({ photoId, alt, updated }: TableImageProps) => {
    const [imageQuery] = images.GetImagesByUrl.useQueries([{ id: photoId, updated }], '')
    const blobUrl = useBlobUrls([imageQuery])

    const isLoading = imageQuery?.isPending
    const src = blobUrl[0]

    return (
        <div className={styles.cellWrapper}>
            {isLoading ? (
                <Loader />
            ) : (
                <div className={styles.photoCell}>
                    <img src={src} alt={alt} />
                </div>
            )}
        </div>
    )
}

export default TableImage
